import React from 'react';

const FormSuccessModal = ({ isOpen, formName, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      <div className="relative pvs-glass rounded-xl shadow-pvs-glow border border-pvs-accent/30 p-8 max-w-md w-full mx-4 text-center">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-green-900/30 border-2 border-green-500 flex items-center justify-center">
          <svg className="w-8 h-8 text-green-400" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
          </svg>
        </div>
        <h2 className="text-xl font-bold text-white mb-2">{formName} submitted successfully</h2>
        <button
          onClick={onClose}
          className="mt-6 px-8 py-3 bg-pvs-accent text-pvs-bg font-semibold rounded-lg shadow-lg hover:bg-pvs-accent-dim transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-pvs-accent/50"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default FormSuccessModal;
